// extracted by mini-css-extract-plugin
module.exports = {"cell":"style_cell__WC2Ww"};